import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PermissionSetListPage from './pages/PermissionSetListPage';
import PermissionSetDetailPage from './pages/PermissionSetDetailPage'; // to build next
import CreatePermissionSetPage from './pages/CreatePermissionSetPage'; // to build next
import AssignPermissionsPage from './pages/AssignPermissionsPage';


const PermissionSetRoutes = () => (
  <Routes>
    <Route path="/create" element={<CreatePermissionSetPage />} />
    <Route path="/assign" element={<AssignPermissionsPage />} />
    <Route path="/" element={<PermissionSetListPage />} />
    <Route path="/:id" element={<PermissionSetDetailPage />} />
  </Routes>
);

export default PermissionSetRoutes;
